import { Dialog } from "@headlessui/react";
import { ExclamationIcon } from "@heroicons/react/solid";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import AppButton from "../buttons/AppButton";
import CenteredModal from "../modal/CenteredModal";
import { useNavigate } from "react-router-dom";
type AlertProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: object) => void;
  userName: string;
  id: string;
  sessionNumber: string | number | null;
  options: {
    id: Number;
    question: string;
    key: string;
    val: string;
  }[];

  values: string[];
};
export default function RatingModal(props: AlertProps) {
  const {
    isOpen,
    onClose,
    onSubmit,
    options,
    values,
    userName,
    id,
    sessionNumber,
  } = props;
  const LocalBasePath = "page.rating";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [rating, setRating] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    setQuestions(options);
    getKeys();
  }, [options]);

  const [questions, setQuestions] = useState(options);
  const getKeys = () => {
    let ratingOption: any = {
      session_id: id,
    };
    options.map((option) => {
      ratingOption[option.key] = option.val;
    });
    setRating(ratingOption);
  };
  const handleRadioChange = (key: string, e: any) => {
    let ratingOption: any = rating;
    ratingOption[key] = e.target.value;
  };
  const handleRatingSubmit = () => {
    onSubmit(rating);
    onClose();
  };

  return (
    <CenteredModal setOpen={onClose} open={isOpen}>
      <div className="sm:w-[512px] ">
        <div className="mb-3 bg-white">
          <div className="sm:flex sm:items-start">
            <div className="flex flex-col w-full">
              <Dialog.Title as="div" className="pb-6">
                <h1 className="font-medium text-lg ">
                  {t("sessionEvaluation") + " " + `#${sessionNumber ?? ""}`}
                </h1>
                <p className="font-medium text-sm text-gray-400 ">{userName}</p>
              </Dialog.Title>
              <div className="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10 overflow-x-auto">
                <table className="min-w-full">
                  <thead className="">
                    <tr>
                      <th
                        scope="col"
                        className="py-3.5 pl-6 pr-3 text-sm text-start font-semibold w-full text-gray-900"
                      ></th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 w-24 text-center text-sm font-semibold text-gray-900"
                      >
                        {t("excellent")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 w-24 text-center text-sm font-semibold text-gray-900"
                      >
                        {t("acceptable")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 w-24 text-center text-sm font-semibold text-gray-900"
                      >
                        {t("weak")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {questions.map((question, index) => {
                      return (
                        <tr key={index}>
                          <td className="whitespace-nowrap py-4 pl-6 pr-3 text-sm font-medium text-gray-900">
                            {question.question}
                          </td>
                          {values.map((option, index) => {
                            return (
                              <td key={index} className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-500">
                                <input
                                  name={question.key}
                                  type="radio"
                                  onChange={(e) =>
                                    handleRadioChange(question.key, e)
                                  }
                                  value={option}
                                  defaultChecked={option == question.val}
                                  className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                />
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row-reverse">
          <AppButton onClick={() => handleRatingSubmit()} buttonShape="primary">
            {t("send")}
          </AppButton>
        </div>
      </div>
    </CenteredModal>
  );
}
